import {
  BriefcaseIcon,
  HomeIcon,
  FolderIcon,
  ColorSwatchIcon,
  BadgeCheckIcon,
  ArchiveIcon,
  ClipboardListIcon,
} from "@heroicons/react/solid";
import { EncryptStorage } from "encrypt-storage";
import { ROUTES } from "Route/ConstantRoute";
const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
const userInfo = encryptStorage.getItem("___info");
const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";

const SidebarRoute = [
  { name: "Beranda", href: ROUTES.dashboard, icon: HomeIcon, current: false },
  {
    name: "Laporan Pemantauan",
    href: ROUTES.report.report_home,
    icon: BriefcaseIcon,
    current: false,
  },
  ...(yuridiksi_user_code === "N"
    ? [
        {
          name: "Master Data",
          icon: ColorSwatchIcon,
          current: false,
          children: [
            {
              name: "Organisasi Kepolisian",
              href: ROUTES.master_data.organization.organization_home,
            },
            {
              name: "Grup Izin Akses",
              href: ROUTES.master_data.permission_group.permission_group_home,
            },
            // {
            //   name: "Tingkat Yurisdiksi",
            //   href: ROUTES.master_data.jurisdiction_level
            //     .jurisdiction_level_home,
            // },
            // {
            //   name: "Jenis Kelamin",
            //   href: ROUTES.master_data.gender.gender_home,
            // },
            // {
            //   name: "Status Operasi",
            //   href: ROUTES.master_data.operation_status.operation_status_home,
            // },
            // {
            //   name: "Tipe Kendaraan",
            //   href: ROUTES.master_data.vehicle_type.vehicle_type_home,
            // },
            // {
            //   name: "Bahan Bakar Kendaraan",
            //   href: ROUTES.master_data.vehicle_fuel_type.vehicle_fuel_type_home,
            // },
            // {
            //   name: "Golongan Darah",
            //   href: ROUTES.master_data.blood_type.blood_type_home,
            // },
            // {
            //   name: "Agama",
            //   href: ROUTES.master_data.religion_type.religion_type_home,
            // },
            // {
            //   name: "Status Kawin",
            //   href: ROUTES.master_data.marital_type.marital_type_home,
            // },
            // {
            //   name: "Kewarganegaraan",
            //   href: ROUTES.master_data.nationality_type.nationality_type_home,
            // },
            // {
            //   name: "Jenis Perangkat",
            //   href: ROUTES.master_data.device_type.device_type_home,
            // },
          ],
        },
      ]
    : []),
  {
    name: "Manajemen Data",
    icon: FolderIcon,
    current: false,
    children: [
      {
        name: "Pengaturan Streaming",
        href: ROUTES.management_data.streaming_device.streaming_device_home,
      },
      // {
      //   name: "Pengaturan Docking Station",
      //   href: ROUTES.management_data.docking_station.docking_station_home,
      // },
      {
        name: "Playback Video",
        href: ROUTES.management_data.playback.playback_home,
      },
      {
        name: "Daftar Pencarian Orang",
        href: ROUTES.management_data.watchlist.watchlist_home,
      },
      {
        name: "Daftar Template Wajah",
        href: ROUTES.management_data.RegisterFace.register_face_home,
      },

      {
        name: "Operasi Kepolisian",
        href: ROUTES.management_data.OperationPolice.operation_police_home,
      },
      {
        name: "Pengguna",
        href: ROUTES.management_data.user_access.user_access_home,
      },
    ],
  },
  {
    name: "Inventaris Barang",
    icon: ArchiveIcon,
    current: false,
    children: [
      // {
      //       name: "Body Worn Camera",
      //       href: ROUTES.inventory.bwc.bwc_home,
      //   },
      {
        name: "Kamera",
        href: ROUTES.inventory.camera.camera_home,
      },
      {
        name: "Kendaraan",
        href: ROUTES.inventory.vehicle.vehicle_home,
      },
    ],
  },
  {
    name: "Log Aktivitas",
    href: ROUTES.log_activity.log_activity_home,
    icon: ClipboardListIcon,
    current: false,
  },
  ...(yuridiksi_user_code === "N"
    ? [
        {
          name: "Lisensi",
          href: ROUTES.license.license_home,
          icon: BadgeCheckIcon,
          current: false,
        },
      ]
    : []),

  // {
  //   name: "Konfigurasi Website",
  //   href: ROUTES.configuration.configuration_home,
  //   icon: CogIcon,
  //   current: false,
  // },
];

export { SidebarRoute };
